export default __webpack_public_path__ + "static/olympicsFlag-617f08e053a5db3b7342680ed0a0c205.svg";